{
  "error500": {
    "title": "500 Error del Servidor",
    "subtitle": "Algo salió mal de nuestro lado",
    "description": "Pedimos disculpas por las molestias. El servidor encontró un error interno y no pudo completar su solicitud. Nuestro equipo ha sido notificado.",
    "tryAgain": "Intentar de nuevo",
    "goHome": "Ir a Inicio",
    "errorCode": "Código de error"
  },
  "sidebar": {
    "title": "Barra Lateral",
    "mobileDescription": "Muestra la barra lateral móvil.",
    "toggle": "Alternar Barra Lateral"
  },
  "nav": {
    "dashboard": "Panel",
    "counters": "Contadores",
    "users": "Usuarios",
    "activityHistory": "Actividad",
    "profile": "Perfil",
    "settings": "Ajustes",
    "collapse": "Colapsar",
    "logout": "Cerrar sesión"
  },
  "theme": {
    "light": "Claro",
    "dark": "Oscuro",
    "system": "Sistema"
  },
  "language": {
    "en": "English",
    "es": "Español",
    "sr": "Српски"
  },
  "common": {
    "user": "Usuario",
    "cancel": "Cancelar",
    "save": "Guardar",
    "dismiss": "Cerrar"
  },
  "login": {
    "title": "Bienvenido de nuevo",
    "description": "Ingresa tus credenciales para iniciar sesión en tu cuenta",
    "identifier": {
      "username": "Nombre de usuario",
      "email": "Correo electrónico",
      "both": "Nombre de usuario o correo electrónico",
      "placeholder": "Ingresa tu {{field}}"
    },
    "password": {
      "label": "Contraseña",
      "placeholder": "Ingresa tu contraseña"
    },
    "button": "Iniciar sesión",
    "button.loading": "Iniciando sesión...",
    "error": {
      "identifierRequired": "{{field}} es obligatorio",
      "passwordLength": "La contraseña debe tener al menos 6 caracteres",
      "failed": "Error al iniciar sesión",
      "unknown": "Ocurrió un error inesperado"
    },
    "forgotPassword": "¿Olvidaste tu contraseña?",
    "noAccount": "¿No tienes una cuenta?",
    "signUp": "Regístrate"
  },
  "invitation": {
    "title": "Completa Tu Registro",
    "description": "Establece tu contraseña para activar tu cuenta",
    "username": "Nombre de usuario",
    "password": "Contraseña",
    "passwordPlaceholder": "Ingresa tu contraseña",
    "confirmPassword": "Confirmar Contraseña",
    "confirmPasswordPlaceholder": "Confirma tu contraseña",
    "button": "Establecer Contraseña y Activar",
    "button.loading": "Configurando...",
    "invalidTitle": "Invitación Inválida",
    "goToLogin": "Ir a Iniciar Sesión",
    "resetPassword": {
      "title": "Restablecer Tu Contraseña",
      "description": "Ingresa una nueva contraseña para tu cuenta",
      "button": "Restablecer Contraseña",
      "button.loading": "Restableciendo..."
    },
    "error": {
      "noToken": "No se proporcionó token de invitación",
      "invalidToken": "Token de invitación inválido o expirado",
      "passwordLength": "La contraseña debe tener al menos 8 caracteres",
      "passwordMismatch": "Las contraseñas no coinciden",
      "failed": "Error al establecer contraseña. Por favor intenta de nuevo."
    }
  },
  "profile": {
    "title": "Mi Cuenta",
    "subtitle": "Gestiona tu perfil y configuración de seguridad",
    "edit": "Editar",
    "verified": "Verificado",
    "updateSuccess": "Perfil actualizado correctamente",
    "updateError": "Error al actualizar el perfil",
    "info": {
      "title": "Información del Perfil",
      "description": "Los detalles de tu cuenta"
    },
    "field": {
      "name": "Nombre Completo",
      "username": "Nombre de Usuario",
      "email": "Correo Electrónico",
      "memberSince": "Miembro Desde"
    },
    "editModal": {
      "title": "Editar Perfil",
      "description": "Actualiza la información de tu perfil"
    },
    "security": {
      "title": "Cambiar Contraseña",
      "description": "Actualiza tu contraseña para mantener tu cuenta segura",
      "currentPassword": "Contraseña Actual",
      "newPassword": "Nueva Contraseña",
      "confirmPassword": "Confirmar Nueva Contraseña",
      "passwordMismatch": "Las contraseñas no coinciden",
      "passwordInvalid": "La contraseña no cumple los requisitos",
      "changeSuccess": "Contraseña cambiada correctamente. Las demás sesiones han sido cerradas.",
      "changeError": "Error al cambiar la contraseña",
      "changeButton": "Cambiar Contraseña"
    },
    "sessions": {
      "currentSession": "Sesión Actual",
      "current": "Actual",
      "device": "Dispositivo",
      "ip": "Dirección IP",
      "lastActive": "Última Actividad",
      "now": "Ahora",
      "unknown": "Desconocido",
      "otherSessions": "Otras Sesiones",
      "otherDescription": "Sesiones activas en otros dispositivos",
      "revokeAll": "Revocar Todas",
      "revoke": "Revocar",
      "revokeSuccess": "Sesión revocada correctamente",
      "revokeError": "Error al revocar la sesión",
      "revokeAllSuccess": "Todas las demás sesiones han sido cerradas",
      "revokeAllError": "Error al revocar las sesiones",
      "noOtherSessions": "No hay otras sesiones activas",
      "lastActiveAt": "Última actividad {{time}}",
      "neverActive": "Nunca activa",
      "confirmRevokeAll": {
        "title": "Revocar Todas las Sesiones",
        "description": "Esto cerrará sesión en todos los demás dispositivos. Permanecerás conectado en este dispositivo."
      },
      "time": {
        "daysAgo": "hace {{count}} d",
        "hoursAgo": "hace {{count}} h",
        "justNow": "justo ahora",
        "minutesAgo": "hace {{count}} min"
      },
      "unknownBrowser": "Navegador desconocido",
      "unknownDevice": "Dispositivo desconocido"
    }
  },
  "settings": {
    "title": "Ajustes",
    "subtitle": "Gestiona las preferencias de tu aplicación",
    "theme": "Tema",
    "themeDescription": "Selecciona tu tema preferido",
    "language": "Idioma",
    "languageDescription": "Selecciona tu idioma preferido"
  },
  "users": {
    "title": "Usuarios",
    "button": {
      "add": "Agregar Usuario",
      "resetPassword": "Restablecer Contraseña",
      "resendInvitation": "Reenviar Invitación",
      "deactivate": "Desactivar",
      "activate": "Activar",
      "demoteFromAdmin": "Quitar rol de Administrador",
      "promoteToAdmin": "Promover a Administrador",
      "delete": "Eliminar"
    },
    "table": {
      "username": "Nombre de usuario",
      "email": "Correo electrónico",
      "name": "Nombre",
      "role": "Rol",
      "status": "Estado",
      "lastLogin": "Último Inicio de Sesión",
      "created": "Creado",
      "actions": "Acciones",
      "noResults": "No se encontraron usuarios",
      "roles": "Roles"
    },
    "status": {
      "active": "Activo",
      "inactive": "Inactivo"
    },
    "date": {
      "never": "Nunca"
    },
    "actions": {
      "label": "Acciones",
      "copyId": "Copiar ID de usuario",
      "editUser": "Editar usuario",
      "openMenu": "Abrir menú",
      "viewDetails": "Ver detalles"
    },
    "filter": {
      "allRoles": "Todos los Roles",
      "allStatus": "Todos los Estados"
    },
    "search": {
      "placeholder": "Buscar por nombre de usuario..."
    },
    "error": {
      "create": "Error al crear usuario",
      "delete": "Error al eliminar usuario",
      "resetPassword": "Error al restablecer contraseña",
      "resendInvitation": "Error al reenviar la invitación",
      "activate": "Error al activar usuario",
      "demote": "Error al quitar el rol al usuario",
      "promote": "Error al promover al usuario",
      "deactivate": "Error al desactivar usuario"
    },
    "role": {
      "USER": "Usuario",
      "ADMIN": "Administrador",
      "SUPERADMIN": "Super Administrador"
    },
    "modal": {
      "add": {
        "title": "Agregar Nuevo Usuario",
        "description": "Crea una nueva cuenta de usuario. Se generará un enlace de invitación.",
        "name": "Nombre",
        "namePlaceholder": "Ingresa el nombre completo...",
        "email": "Correo electrónico",
        "emailPlaceholder": "Ingresa el correo...",
        "emailOptional": "Correo electrónico (opcional)",
        "identifierHint": "Introduce un nombre de usuario, un correo o ambos — el usuario inicia sesión con lo que establezcas.",
        "username": "Nombre de usuario",
        "usernamePlaceholder": "Ingresa nombre de usuario...",
        "role": "Rol",
        "password": "Contraseña (opcional)",
        "passwordPlaceholder": "Deja vacío para enviar enlace de invitación",
        "passwordHint": "Si se deja vacío, se generará un enlace de invitación para que el usuario establezca su propia contraseña.",
        "button": "Crear Usuario",
        "rolePlaceholder": "Selecciona un rol"
      },
      "invitation": {
        "copied": "Enlace copiado",
        "copyFailed": "No se pudo copiar el enlace. Cópialo manualmente.",
        "title": "Enlace de Invitación",
        "message": "Comparte este enlace con el usuario para completar su registro.",
        "emailSent": "La invitación fue enviada por correo a {{email}}.",
        "emailFailed": "No se pudo enviar la invitación por correo a {{email}}. Comparte el enlace de abajo manualmente.",
        "button": {
          "copy": "Copiar Enlace",
          "done": "Hecho"
        }
      },
      "deactivate": {
        "title": "Desactivar Usuario",
        "message": "¿Estás seguro de que deseas desactivar a {{username}}?",
        "button": "Desactivar"
      },
      "selfReset": {
        "title": "Restablecer Tu Contraseña",
        "message": "Estás a punto de restablecer tu propia contraseña. Serás desconectado y necesitarás usar el enlace de invitación para volver a iniciar sesión.",
        "button": "Restablecer Contraseña"
      },
      "button": {
        "cancel": "Cancelar"
      },
      "delete": {
        "title": "Eliminar Usuario",
        "message": "Esto elimina a {{username}} para siempre y no se puede deshacer. Se cierran todas sus sesiones, no podrá volver a iniciar sesión, y su nombre de usuario y su correo quedan libres para otra persona. Para solo quitarle el acceso, desactívalo.",
        "confirm": "Escribe {{username}} para confirmar",
        "button": "Eliminar Usuario"
      }
    },
    "card": {
      "total": "en total"
    },
    "pagination": {
      "of": "de",
      "page": "Página",
      "rowsPerPage": "Filas por página"
    }
  },
  "counters": {
    "title": "Contadores",
    "description": "Gestiona tus contadores",
    "newCounter": "Nuevo Contador",
    "empty": "Aún no hay contadores. ¡Crea uno para comenzar!",
    "lastUpdated": "Última actualización:",
    "modal": {
      "title": "Crear Nuevo Contador",
      "description": "Ingresa un nombre para tu nuevo contador.",
      "nameLabel": "Nombre del Contador",
      "namePlaceholder": "Ingresa el nombre del contador...",
      "cancel": "Cancelar",
      "create": "Crear"
    },
    "clearAll": "Borrar Todo",
    "clearAllModal": {
      "cancel": "Cancelar",
      "confirm": "Eliminar Todo",
      "description": "¿Seguro que quieres eliminar los {{count}} contadores? Esta acción no se puede deshacer.",
      "title": "Borrar Todos los Contadores"
    },
    "error": {
      "create": "Error al crear el contador",
      "decrement": "Error al decrementar el contador",
      "delete": "Error al eliminar el contador",
      "deleteAll": "Error al eliminar todos los contadores",
      "increment": "Error al incrementar el contador",
      "reset": "Error al reiniciar el contador"
    },
    "loadError": "No se pudieron cargar los contadores.",
    "noResults": "Ningún contador coincide con tu búsqueda.",
    "search": "Buscar contadores...",
    "toast": {
      "incremented": "Contador incrementado"
    },
    "total": "en total"
  },
  "activity": {
    "table": {
      "timestamp": "Marca de Tiempo",
      "action": "Acción",
      "entityType": "Tipo de Entidad",
      "user": "Usuario",
      "ip": "Dirección IP",
      "status": "Estado",
      "noResults": "No se encontraron registros de actividad"
    },
    "status": {
      "success": "Éxito",
      "failed": "Fallido"
    },
    "filter": {
      "clear": "Limpiar",
      "allActions": "Todas las Acciones",
      "allEntities": "Todos los Tipos de Entidad",
      "allStatus": "Todos los Estados"
    },
    "entityType": {
      "session": "Sesión",
      "user": "Usuario",
      "counter": "Contador"
    },
    "action": {
      "LOGIN": "Inicio de Sesión",
      "LOGIN_FAILED": "Inicio Fallido",
      "LOGOUT": "Cierre de Sesión",
      "LOGOUT_ALL": "Cerrar Todas",
      "TOKEN_REFRESH": "Renovar Token",
      "CREATE": "Crear",
      "UPDATE": "Actualizar",
      "DELETE": "Eliminar",
      "PASSWORD_SET": "Contraseña Establecida",
      "PASSWORD_CHANGE": "Cambio de Contraseña",
      "PASSWORD_RESET": "Restablecer Contraseña",
      "REGISTER": "Registro",
      "EMAIL_VERIFY": "Verificar Email",
      "RESEND_VERIFICATION": "Reenviar Verificación"
    },
    "search": {
      "placeholder": "Buscar por nombre de usuario, IP, entidad..."
    },
    "button": {
      "details": "Detalles"
    },
    "modal": {
      "title": "Detalles de Actividad"
    },
    "details": {
      "error": "Error",
      "previousState": "Estado Anterior",
      "newState": "Nuevo Estado",
      "metadata": "Metadatos",
      "userAgent": "Agente de Usuario"
    },
    "pagination": {
      "of": "de",
      "page": "Página",
      "rowsPerPage": "Filas por página"
    }
  },
  "activityHistory": {
    "title": "Historial de Actividad",
    "description": "Ver registros de auditoría del sistema y actividad del usuario",
    "card": {
      "total": "registros"
    }
  },
  "toast": {
    "sessionExpired": "Sesión expirada. Por favor inicia sesión de nuevo.",
    "deviceMismatch": "Esta sesión pertenece a otro dispositivo. Por favor inicia sesión de nuevo.",
    "rateLimited": "Demasiadas solicitudes. Por favor intenta de nuevo más tarde.",
    "reconnecting": "Reconectando…",
    "unreachable": "No pudimos conectar con el servidor — puede estar reiniciándose. No se guardó nada; inténtalo de nuevo en un momento."
  },
  "backend": {
    "accountLocked": "Demasiados intentos fallidos. Inténtalo de nuevo en {{seconds}} segundos",
    "accountLockedTitle": "Cuenta bloqueada temporalmente",
    "badRequest": "La solicitud no es válida",
    "cannotAssignCustomerRole": "El rol de Cliente no se puede asignar a usuarios gestionados por administradores",
    "cannotDeactivateOwnAccount": "No puedes desactivar tu propia cuenta",
    "cannotDeleteOwnAccount": "No puedes eliminar tu propia cuenta",
    "cannotDeleteSuperAdmin": "Los usuarios Super Administradores no se pueden eliminar",
    "cannotModifyOwnRoles": "No puedes modificar tus propios roles",
    "cannotModifyOwnSuperAdmin": "No puedes modificar tu propio estado de Super Administrador",
    "cannotResendSuperAdminInvitation": "No se pueden reenviar invitaciones a usuarios Super Administradores",
    "cannotResetSuperAdminPassword": "La contraseña de un Super Administrador no se puede restablecer aquí",
    "cannotUpdateSuperAdmin": "Los usuarios Super Administradores no se pueden modificar",
    "conflict": "Esto ya existe",
    "counterNotFound": "Contador no encontrado",
    "currentPasswordIncorrect": "La contraseña actual es incorrecta",
    "emailAlreadyVerified": "Este correo electrónico ya está verificado. Puedes iniciar sesión.",
    "emailExists": "Este correo electrónico ya está registrado",
    "emailNotVerified": "Verifica tu correo electrónico antes de iniciar sesión",
    "emailRequired": "El correo electrónico es obligatorio",
    "fetchActivityFailed": "No se pudo cargar la actividad",
    "fetchProfileFailed": "No se pudo cargar tu perfil",
    "fetchSessionsFailed": "No se pudieron cargar tus sesiones",
    "fetchUsersFailed": "No se pudieron cargar los usuarios",
    "forbidden": "No tienes permiso para hacer eso",
    "identifierInUse": "Ese nombre de usuario o correo electrónico ya está en uso",
    "identifierRequired": "El nombre de usuario o correo electrónico es obligatorio",
    "invalidCredentials": "Nombre de usuario o contraseña incorrectos",
    "invalidEmail": "Formato de correo electrónico no válido",
    "invalidInvitationToken": "Enlace de invitación inválido o expirado",
    "invalidResetToken": "Este enlace para restablecer la contraseña no es válido o ha expirado",
    "invalidVerificationToken": "Este enlace de verificación no es válido o ha expirado",
    "logoutAllFailed": "No se pudieron cerrar las demás sesiones",
    "logoutFailed": "Error al cerrar sesión",
    "newPasswordSameAsCurrent": "La nueva contraseña debe ser diferente de la actual",
    "noPlatformAccess": "Tu cuenta no tiene acceso a esta aplicación",
    "notFound": "No encontrado",
    "onlySuperAdminsCreateSuperAdmins": "Solo los Super Administradores pueden crear usuarios Super Administradores",
    "onlySuperAdminsManageSuperAdmins": "Solo los Super Administradores pueden gestionar el estado de Super Administrador",
    "passwordAlreadySet": "Este usuario ya estableció una contraseña. Usa el restablecimiento de contraseña.",
    "passwordComplexity": "La contraseña no cumple los requisitos",
    "passwordMinLength": "La contraseña debe tener al menos {{count}} caracteres",
    "passwordNotSet": "Esta cuenta no tiene una contraseña establecida",
    "passwordSetupRequired": "Debes establecer tu contraseña antes de iniciar sesión",
    "profileNotFound": "Perfil no encontrado",
    "registrationFailed": "Error en el registro",
    "registrationUnavailable": "El registro no está disponible",
    "resetPasswordFailed": "Error al restablecer la contraseña",
    "revokeSessionFailed": "No se pudo revocar la sesión",
    "securityCheckFailed": "Falló la comprobación de seguridad. Recarga la página e inténtalo de nuevo.",
    "serverError": "Algo salió mal de nuestro lado. Inténtalo de nuevo.",
    "sessionNotFound": "Sesión no encontrada",
    "tooManyLoginAttempts": "Demasiados intentos de inicio de sesión. Inténtalo de nuevo en {{seconds}} segundos",
    "updateUserFailed": "Error al actualizar el usuario",
    "userNotFound": "Usuario no encontrado",
    "usernameDerivedFromEmail": "El nombre de usuario se deriva del correo electrónico cuando el inicio de sesión es por correo",
    "usernameExists": "El nombre de usuario ya existe",
    "usernameRequired": "El nombre de usuario es obligatorio",
    "verificationFailed": "Verificación fallida",
    "verificationUnavailable": "La verificación de correo electrónico no está disponible",
    "verifyInvitationFailed": "No se pudo verificar la invitación",
    "accountDeactivated": "La cuenta está desactivada",
    "accountLockedFor": "Cuenta bloqueada durante {{seconds}} segundos",
    "invalidPassword": "Contraseña incorrecta",
    "invalidPasswordLocked": "Contraseña incorrecta – cuenta bloqueada durante {{seconds}} segundos",
    "passwordPolicyDefault": "La contraseña debe contener mayúsculas, minúsculas, un número y un carácter especial",
    "platformAccessDenied": "Acceso denegado para esta plataforma ({{platform}})",
    "sendVerificationFailed": "No se pudo enviar el correo de verificación"
  },
  "dataTable": {
    "clearFilters": "Limpiar filtros",
    "columns": "Columnas",
    "noResults": "Sin resultados.",
    "pagination": {
      "next": "Siguiente",
      "pageOf": "Página {{page}} de {{pageCount}}",
      "perPage": "{{count}} / página",
      "previous": "Anterior",
      "showing": "Mostrando {{from}} a {{to}} de {{total}} resultados"
    },
    "rowsSelected": "{{selected}} de {{total}} fila(s) seleccionada(s).",
    "searchPlaceholder": "Buscar...",
    "column": {
      "actions": "Acciones",
      "createdAt": "Creado",
      "isActive": "Estado",
      "lastLoginAt": "Último Acceso",
      "name": "Nombre",
      "roles": "Roles",
      "username": "Nombre de usuario"
    }
  },
  "forgotPassword": {
    "backToLogin": "Volver a iniciar sesión",
    "description": "Ingresa tu correo electrónico y te enviaremos un enlace para restablecerla.",
    "email": "Correo electrónico",
    "emailPlaceholder": "Ingresa tu correo electrónico",
    "sent": {
      "description": "Si existe una cuenta con este correo electrónico, recibirás un enlace para restablecer la contraseña.",
      "title": "Revisa tu correo electrónico"
    },
    "submit": "Enviar Enlace",
    "title": "Olvidé mi Contraseña"
  },
  "password": {
    "error": {
      "complexity": "La contraseña no cumple los requisitos",
      "minLength": "La contraseña debe tener al menos {{count}} caracteres"
    },
    "requirement": {
      "complexity": "Cumple los requisitos de complejidad",
      "minLength": "Al menos {{count}} caracteres"
    },
    "show": "Mostrar contraseña",
    "hide": "Ocultar contraseña"
  },
  "register": {
    "button": "Crear cuenta",
    "button.loading": "Creando cuenta...",
    "confirmPassword": {
      "label": "Confirmar Contraseña",
      "placeholder": "Confirma tu contraseña"
    },
    "description": "Ingresa tus datos para crear tu cuenta",
    "email": {
      "label": "Correo electrónico",
      "placeholder": "Ingresa tu correo electrónico"
    },
    "error": {
      "failed": "Error en el registro. Inténtalo de nuevo.",
      "invalidEmail": "Ingresa un correo electrónico válido",
      "nameRequired": "El nombre es obligatorio",
      "passwordLength": "La contraseña debe tener al menos 8 caracteres",
      "passwordMismatch": "Las contraseñas no coinciden"
    },
    "hasAccount": "¿Ya tienes una cuenta?",
    "name": {
      "label": "Nombre",
      "placeholder": "Ingresa tu nombre"
    },
    "password": {
      "label": "Contraseña",
      "placeholder": "Ingresa tu contraseña"
    },
    "signIn": "Iniciar sesión",
    "success": "¡Registro exitoso! Revisa tu correo electrónico para verificar tu cuenta.",
    "title": "Crea una cuenta"
  },
  "resetPassword": {
    "confirmPassword": "Confirmar Contraseña",
    "description": "Ingresa tu nueva contraseña a continuación.",
    "error": "Error al restablecer la contraseña",
    "goToLogin": "Ir a Iniciar Sesión",
    "invalid": {
      "description": "Este enlace para restablecer la contraseña ha expirado o no es válido. Solicita uno nuevo.",
      "title": "Enlace Inválido o Expirado"
    },
    "newPassword": "Nueva Contraseña",
    "passwordInvalid": "La contraseña no cumple los requisitos",
    "passwordMismatch": "Las contraseñas no coinciden",
    "requestNew": "Solicitar Nuevo Enlace",
    "submit": "Restablecer Contraseña",
    "success": "Contraseña restablecida correctamente",
    "success.description": "Serás redirigido al inicio de sesión en breve.",
    "success.title": "Contraseña Restablecida",
    "title": "Restablecer Contraseña"
  },
  "verifyEmail": {
    "error": {
      "invalidToken": "Este enlace de verificación no es válido o ha expirado.",
      "noToken": "No se proporcionó un token de verificación",
      "title": "Verificación Fallida"
    },
    "goToLogin": "Ir a Iniciar Sesión",
    "needAccount": "¿No tienes una cuenta?",
    "resend": {
      "button": "Reenviar Correo de Verificación",
      "cancel": "Cancelar",
      "email": {
        "label": "Correo Electrónico",
        "placeholder": "Ingresa tu correo electrónico"
      },
      "emailRequired": "Ingresa tu correo electrónico",
      "sending": "Enviando...",
      "submit": "Enviar",
      "success": "Si tu correo electrónico está registrado, recibirás un correo de verificación."
    },
    "signUp": "Regístrate",
    "success": {
      "description": "Tu correo electrónico ha sido verificado correctamente. Ya puedes iniciar sesión en tu cuenta.",
      "redirect": "Redirigiendo al inicio de sesión...",
      "title": "¡Correo Verificado!"
    }
  },
  "unsavedChanges": {
    "title": "¿Salir sin guardar?",
    "body": "Se perderán tus cambios.",
    "stay": "Quedarme",
    "leave": "Salir"
  },
  "richText": {
    "bold": "Negrita",
    "italic": "Cursiva",
    "underline": "Subrayado",
    "strike": "Tachado",
    "heading": "Título",
    "paragraph": "Párrafo",
    "bullets": "Lista con viñetas",
    "numbers": "Lista numerada",
    "quote": "Cita"
  }
}
